export default {
  myAssetLibrary: 'My Assets',
  cancel: 'Cancel',
  confirm: 'Confirm',
  continue: 'Continue',
  filter: {
    search: 'Search',
    assetName: 'Asset Name',
    assetId: 'Asset ID',
    updateTime: 'Updated Time',
    createTime: 'Creation Time',
    format: 'Format',
    type: 'Types',
    image: 'Images',
    video: 'Video',
    audio: 'Audio',
    h5: 'H5',
    psd: 'PSD',
    font: 'Font',
    zip: 'Zip file',
    dragonbone: 'DragonBones',
    seqframe: 'Sequence',
    screenRecordFile: 'Screen Recording Asset File',
    proportion: 'Ratio',
    direction: 'Orientation',
    horizontal: 'Landscape',
    vertical: 'Portrait',
    square: 'Square',
    duration: 'Duration',
    second: 'Second',
    minute: 'Minute',
    hour: 'Hour',
    codeRate: 'Bitrate',
    fileSize: 'File size',
    size: 'Dimension',
    date: 'Date',
    width: 'Width',
    high: 'High',
    widthSize: 'Width',
    highSize: 'High',
    other: 'Other',
    min: 'Smallest',
    max: 'Maximum',
    upload: 'Upload',
    share: 'Team sharing',
    synchronization: 'System synchronization',
    playturbo: 'Playturbo',
    source: 'Source Of Assets',
    today: 'Today',
    week: 'Past week',
    searchSize: 'Size',
    createdate: 'Creation Date',
    updatedate: 'Updated Date',
  },
}
